import { useState, useEffect } from 'react';
import { useRouter } from 'next/router';

const useBlogsHooks = (data, articlesPerPage = 15) => {
  const router = useRouter();
  const { articleTag, title, page, category } = router.query;
  const [currentPage, setCurrentPage] = useState(page ? parseInt(page) : 1);

  // Add null check for data
  const safeData = data || [];
 
  const filteredArticles = safeData.filter((article) => {
    // Add comprehensive null checks
    if (!article || !article.data) {
      return false;
    }

    const findByText = title
      ? (article.data.title || '').toLowerCase().includes(title.toLowerCase())
      : true;

    const filterByTags = articleTag
      ? (article.data.article_tags || []).find((tag) => tag?.article_tag?.uid === articleTag)
      : true;

    const filterByCategory = category
      ? (article.data.category?.id === category)
      : true;

    return filterByTags && findByText && filterByCategory;
  });

  const totalPages = Math.ceil(filteredArticles.length / articlesPerPage);
  const paginatedArticles = filteredArticles.slice(
    (currentPage - 1) * articlesPerPage,
    currentPage * articlesPerPage,
  );

  useEffect(() => {
    if (page) {
      const pageNum = parseInt(page);
      if (pageNum !== currentPage && pageNum >= 1 && pageNum <= totalPages) {
        setCurrentPage(pageNum);
      }
    } else if (currentPage !== 1) {
      setCurrentPage(1);
    }
  }, [page, totalPages, currentPage]);

  useEffect(() => {
    if (!page && router.isReady) {
      const newQuery = { ...router.query, page: 1 };
      router.push({
        pathname: router.pathname,
        query: newQuery
      }, undefined, { shallow: true });
    }
  }, [router.isReady]);

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
      
      const newQuery = { ...router.query, page: pageNumber };
      
      router.push({
        pathname: router.pathname,
        query: newQuery
      }, undefined, { shallow: true });
      
      window.scrollTo(0, 0);
    }
  };

  const changeArticle = (newArticleUid) => (e) => {
    e.stopPropagation();
    e.preventDefault();

    const query = { articleTag: newArticleUid };
    if (title) query.title = title;

    router.push(
      { pathname: '/blog', query },
      undefined,
      { shallow: true }
    );
  };

  return {
    currentPage,
    totalPages,
    paginatedArticles,
    filteredArticles,
    handlePageChange,
    changeArticle
  };
};

export default useBlogsHooks;